<div class="nxe-tree">
  @if (buttonHome$ | async) {
    <ng-container *ngTemplateOutlet="homeTmp"> </ng-container>
}
  @if (tree$ | async; as tree) {
    <ng-container *ngTemplateOutlet="treeTmp; context: { nodes: tree }"></ng-container>
  }
</div>

<ng-template #homeTmp>
  <ul class="nxe-tree-ul__home">
      <li>
          <div class="item" (click)="home()">
              <i-tabler class="icon-18 icon-home" name="home"></i-tabler>
              <div class="dir-name" >Home</div>
          </div>
      </li>
  </ul>
</ng-template>

<ng-template #treeTmp let-nodes="nodes">
  @if (nodes && nodes.length > 0) {
    <ul class="nxe-tree-ul">
      @for (node of nodes; track $index) {
        @if (!node.isLeaf) {
          <li>
            <div class="item" (click)="open(node)" [ngClass]="{ selected: (selectedId$ | async) === node.id }"
            cdkDropList (cdkDropListDropped)="onDrop($event, node)">
              @if (!node.expanded) {
                <div class="chevron" (click)="expand($event, node)"><i class="nxe-angle-right" aria-hidden="true"></i>
                </div>
              } @else {
                <div class="chevron" (click)="collapse($event, node)">
                  <i class="nxe-angle-down" aria-hidden="true"></i>
                </div>
              }
              <div class="dir-icon">
                <i-tabler class="icon-24" name="folder-filled"></i-tabler>
                <!--i class="nxe-folder" aria-hidden="true"></i>-->
              </div>
              <div class="dir-name" [innerText]="node.name"></div>
            </div>
            @if (node.expanded) {
              <ng-container *ngTemplateOutlet="treeTmp; context: { nodes: node.children }"></ng-container>
            }
          </li>
        }

        @if (node.isLeaf && showFileTree) {
          <li>
            <div class="item" (click)="select(node)" [ngClass]="{ selected: (selectedId$ | async) === node.id }" cdkDrag>
              <div class="dir-icon">
                <i class="nxe-doc"></i>
              </div>
              <div class="dir-name" [innerText]="node.name"></div>
            </div>
          </li>
        }

      }

    </ul>
  }
</ng-template>
